export var AbAnalyticEventEnum = /* @__PURE__ */ ((AbAnalyticEventEnum2) => {
  AbAnalyticEventEnum2["ViewSection"] = "ab_view_section";
  AbAnalyticEventEnum2["SelectItem"] = "ab_select_item";
  AbAnalyticEventEnum2["ViewSectionCatalog"] = "ab_view_section_catalog";
  AbAnalyticEventEnum2["SelectItemCatalog"] = "ab_select_item_catalog";
  AbAnalyticEventEnum2["ViewForm"] = "ab_view_form";
  AbAnalyticEventEnum2["StartForm"] = "ab_start_form";
  AbAnalyticEventEnum2["SubmitForm"] = "ab_submit_form";
  AbAnalyticEventEnum2["SubmitFormSuccess"] = "ab_submit_form_success";
  return AbAnalyticEventEnum2;
})(AbAnalyticEventEnum || {});
